import { Avatar } from "@admin/components/atoms/Avatar";

interface InfoProps {
  name?: string;
  userName?: string;
  userPhoto?: string;
  onClick?: () => void;
  children?: React.ReactNode;
}

export function Info({
  name,
  userName,
  userPhoto,
  onClick,
  children,
}: InfoProps) {
  return (
    <button
      className="flex items-center px-4 py-2 gap-2.5 hover:bg-gray-100 w-full rounded-md"
      onClick={onClick}
      type="button"
    >
      <Avatar alt={name} src={userPhoto} />
      <div className="flex flex-row justify-between items-center w-full">
        <div className="flex flex-col items-start">
          <span className="text-sm font-medium text-gray-900 mb-px">
            {name}
          </span>
          <span className="text-2sm text-gray-700 font-normal">
            @{userName}
          </span>
        </div>
        {children}
      </div>
    </button>
  );
}
